import React from 'react';
import {Link} from 'react-router-dom';
import {Container, Typography, Button, Grid} from '@material-ui/core';
import CartItem from './CartItem/CartItem';
import useStyles from './styles';

const Cart = ({cart, handleRemoveFromCart, handleUpdateCartQty, handleEmptyCart}) => {
    const classes = useStyles();

    const EmptyCart = () => (
        <Typography variant="subtitle1">Your cart is empty. <Link className={classes.link} to="/">Time to shop!!</Link></Typography>
    );

    const FilledCart = () => (
        <>
        <Grid container spacing={3}>
            {cart.line_items.map((item) => (
                <Grid item xs={12} sm={4} key={item.id}>
                    <CartItem item={item} onUpdateCartQty={handleUpdateCartQty} onRemoveFromCart={handleRemoveFromCart} />
                </Grid>
            ))}
        </Grid>
        <div className={classes.cardDetails}>
            <Typography variant="h4">
                Subtotal: {cart.subtotal.formatted_with_symbol}
            </Typography>
            <div>
                <Button className={classes.emptyButton} size="large" type="button" variant="contained" color="secondary" onClick={handleEmptyCart}>Empty Cart</Button>
                <Button className={classes.checkoutButton} size="large" type="button" variant="contained" component={Link} to="/checkout">Checkout</Button>
            </div>
        </div>
        </>
    );

    if(!cart.line_items) return 'LOADING.......'

    return (
        <main className={classes.content}>
            <Container>
                <div className={classes.toolbar}/>
                <Typography className={classes.title} variant="h3" gutterBottom>
                    Your Shopping Cart:
                </Typography>
                {!cart.line_items.length ? <EmptyCart /> : <FilledCart />}
            </Container>
        </main>
    )
}

export default Cart
